import { UseLazyApiCallV2 } from "hooks";
import { useEffect, useRef } from "react";

export const useGetInitialData = () => {
  const socketRef = useRef();
  const SOCKET_FOR_PROCESSING =
    "wss://eylnvsnqp7.execute-api.eu-central-1.amazonaws.com/dev/";

  const [
    getUploadedVideos,
    { data: uploadedVideoList, isLoading: uploadedVideosLoading },
  ] = UseLazyApiCallV2({
    url: "/get_simulation_videos",
    method: "POST",
    paramsData: { token: "313323" },
  });

  useEffect(() => {
    const socket = getSocketConnection();
    return () => {
      socket.close();
    };
  }, []);

  function getSocketConnection() {
    const socket = new WebSocket(SOCKET_FOR_PROCESSING);

    socketRef.current = socket;
    // Event listeners for WebSocket events
    socket.onopen = () => {
      console.log("Processing WebSocket connection established");
    };

    return socket; // Return the socket object
  }

  function handleRequestProcess() {
    socketRef.current.send(JSON.stringify({ request: "process" }));
  }

  return {
    getUploadedVideos,
    uploadedVideoList,
    uploadedVideosLoading,
    handleRequestProcess,
  };
};
